/** A namespace that normalises Zoho URLs which paths starts with `/#/`.
 * The leading hash breaks the web URL implementation and causes it to parse the resting path as a hash.
 *
 *
 * ```typescript
 * // Example of the URL not being parsed correctly
 *
 * const url = new URL(`https://zoho.funkey.be/#/sign-quotes/eyJpdiI6Iis3Ynp4MDNsSk5Va3VOWEszN3Bzbmc9PSIsInZhbHVlIjoiZ0s5S1cvbWJQcWxXVDZDNDhlOUFxdUo2NitJY2VlajUwWVNWYlJaNGpVOD0iLCJtYWMiOiJjNTNjYzRkZDcwZjY1ZmNkMDYzYTRjMWFlMjM5MzU3MzdiZGMzYzAwNmNkM2Q1ZWQ0Mzg3Mzk2YmEzNjE2Yzc3IiwidGFnIjoiIn0=?type=D`)
 *
 * url.pathname // '/'
 * url.hash // '#/sign-quotes/eyJpdiI6Iis3Ynp4MDNsSk5Va3VOWEszN3Bzbmc9PSIsInZhbHVlIjoiZ0s5S1cvbWJQcWxXVDZDNDhlOUFxdUo2NitJY2VlajUwWVNWYlJaNGpVOD0iLCJtYWMiOiJjNTNjYzRkZDcwZjY1ZmNkMDYzYTRjMWFlMjM5MzU3MzdiZGMzYzAwNmNkM2Q1ZWQ0Mzg3Mzk2YmEzNjE2Yzc3IiwidGFnIjoiIn0=?type=D'
 * url.search // ''
 * ```
 */
export namespace ZohoHashURL {
    export function toNormalisedURL(url: string) {
        const HASH_URI_ENCODED = encodeURIComponent('#');

        return new URL(url.replace('/#/', `/${HASH_URI_ENCODED}/`));
    }

    export function toString(normalisedURL: URL) {
        const HASH_URI_ENCODED = encodeURIComponent('#');

        return normalisedURL.toString().replace(`/${HASH_URI_ENCODED}/`, '/#/');
    }
}
